import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import { Client } from 'src/typings';
import { ClientService } from '../client.service';

@Component({ selector: 'app-profile', templateUrl: './profile.component.html', styleUrls: ['./profile.component.scss'] })
export class ProfileComponent implements OnInit, OnDestroy {
  client?: Client;
  loading = true;
  error = '';
  selectedTab = 0;
  readonly tabs = ['orders', 'cars', 'markup', 'calls', 'reports', 'settlements'];
  accountOrgId = 0;
  mobileLayout = typeof window !== 'undefined' && window.innerWidth <= 900;
  returnFilters: { phone?: string; name?: string; id?: string } = {};
  private subscriptions = new Subscription();
  private revision = 0;
  constructor(private route: ActivatedRoute, private clientService: ClientService, private router: Router) {}

  @HostListener('window:resize')
  updateMobileLayout() { this.mobileLayout = window.innerWidth <= 900; }

  ngOnInit() {
    this.subscriptions.add(this.route.queryParamMap.subscribe(params => {
      this.selectedTab = Math.max(0, this.tabs.indexOf(params.get('tab') || 'orders'));
      this.accountOrgId = Number(params.get('org_id')) || this.accountOrgId;
      this.returnFilters = { phone: params.get('returnPhone') || undefined,
        name: params.get('returnName') || undefined, id: params.get('returnId') || undefined };
    }));
    this.subscriptions.add(this.route.params.subscribe(() => this.load()));
  }

  async load() {
    const revision = ++this.revision;
    this.loading = true; this.error = ''; this.client = undefined;
    try {
      const client = await firstValueFrom(this.clientService.getOne(Number(this.route.snapshot.params.id)));
      if (revision !== this.revision) return;
      if (!client?.id) throw new Error('Client missing');
      this.client = client;
    } catch {
      if (revision === this.revision) this.error = 'Не удалось открыть клиента. Проверьте доступ и повторите загрузку.';
    } finally { if (revision === this.revision) this.loading = false; }
  }

  selectTab(index: number) {
    if (index === this.selectedTab) return;
    this.selectedTab = index;
    this.router.navigate([], { relativeTo: this.route, queryParamsHandling: 'merge', replaceUrl: true,
      queryParams: { tab: index ? this.tabs[index] : null } });
  }

  ngOnDestroy() { this.revision++; this.subscriptions.unsubscribe(); }
}
